module["exports"] = [
  "InnoDB",
  "MyISAM",
  "MEMORY",
  "CSV",
  "BLACKHOLE",
  "ARCHIVE"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/database/engine.js
// module id = 2597
// module chunks = 1610